module.exports = __webpack_public_path__ + "static/img/select_filter_arrow.24ae0a13.svg";